/**
 * WordPress dependencies
 */
import { useMergeRefs } from '@wordpress/compose';
import { forwardRef, useRef } from '@wordpress/element';

/**
 * Internal dependencies
 */
import { ControlWithError } from '../control-with-error';
import TextControl from '../../text-control';
import { jsx as _jsx } from "react/jsx-runtime";
const UnforwardedValidatedTextControl = ({
  required,
  customValidity,
  markWhenOptional,
  ...restProps
}, forwardedRef) => {
  const validityTargetRef = useRef(null);
  const mergedRefs = useMergeRefs([forwardedRef, validityTargetRef]);
  return /*#__PURE__*/_jsx(ControlWithError, {
    required: required,
    markWhenOptional: markWhenOptional,
    customValidity: customValidity,
    getValidityTarget: () => validityTargetRef.current,
    children: /*#__PURE__*/_jsx(TextControl, {
      ref: mergedRefs,
      ...restProps
    })
  });
};
export const ValidatedTextControl = forwardRef(UnforwardedValidatedTextControl);
ValidatedTextControl.displayName = 'ValidatedTextControl';